export default [
  {
    path: '/changhong',
    component: () => import(/* webpackChunkName: 'changhong' */ '@/pages/changhong/index.vue'),
    children: [
      {
        path: 'login',
        component: () => import(/* webpackChunkName: 'changhong' */ '@/pages/changhong/Login.vue'),
        meta: {
          title: '佳华好伙伴答谢会'
        }
      },
      {
        path: 'makeInvitation',
        component: () => import(/* webpackChunkName: 'changhong' */ '@/pages/changhong/MakeInvitation.vue'),
        meta: {
          title: '佳华好伙伴答谢会'
        }
      },
      {
        path: 'clientList',
        component: () => import(/* webpackChunkName: 'changhong' */ '@/pages/changhong/ClientList.vue'),
        meta: {
          title: '佳华好伙伴答谢会'
        }
      },
      {
        path: 'invitation',
        component: () => import(/* webpackChunkName: 'changhong' */ '@/pages/changhong/Invitation.vue'),
        meta: {
          title: '佳华好伙伴答谢会'
        }
      },
      {
        path: 'signUp',
        component: () => import(/* webpackChunkName: 'changhong' */ '@/pages/changhong/SignUp.vue'),
        meta: {
          title: '佳华好伙伴答谢会'
        }
      },
      {
        path: 'success',
        component: () => import(/* webpackChunkName: 'changhong' */ '@/pages/changhong/Success.vue'),
        meta: {
          title: '佳华好伙伴答谢会'
        }
      },
      {
        path: 'fail',
        component: () => import(/* webpackChunkName: 'changhong' */ '@/pages/changhong/Fail.vue'),
        meta: {
          title: '佳华好伙伴答谢会'
        }
      },
      {
        path: 'liveLogin',
        component: () => import(/* webpackChunkName: 'changhong' */ '@/pages/changhong/LiveLogin.vue'),
        meta: {
          title: '佳华好伙伴答谢会'
        }
      }
    ]
  }
]
